import { createRouter, createWebHistory } from 'vue-router'
import MethanogenList from '../components/MethanogenList.vue'
import About from '../components/About.vue'
import Plasmid from '../components/Plasmid.vue'
import Virus from '../components/Virus.vue'
import StrainDetail from '../components/StrainDetail.vue'
import CheckM2 from '../components/CheckM2.vue'
import RagTag from '../components/RagTag.vue'
import RagoutTool from '../components/RagoutTool.vue'
import EzAAITool from '../components/EzAAITool.vue'
import BaktaAnalyzer from '@/components/BaktaAnalyzer.vue'
import TomeOGT from '@/components/TomeOGT.vue'
import DiamondAnalyzer from '@/components/DiamondAnalyzer.vue'
import MethArCTBeta from '@/components/MethArCTBeta.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MethanogenList
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/plasmid',
    name: 'Plasmid',
    component: Plasmid
  },
  {
    path: '/virus',
    name: 'Virus',
    component: Virus
  },
  {
    path: '/strain/:assemblyAccession',
    name: 'StrainDetail',
    component: StrainDetail,
    props: true
  },

  {
    path: '/checkm2',
    name: 'CheckM2',
    component: CheckM2
  },
  {
    path: '/tools/ragtag',
    name: 'RagTag',
    component: RagTag
  },
  {
    path: '/tools/ragout',
    name: 'RagoutTool',
    component: RagoutTool
  },
  {
    path: '/tools/ezaai',
    name: 'EzAAITool',
    component: EzAAITool
  },
  {
    path: '/tools/bakta',
    name: 'BaktaAnalyzer',
    component: BaktaAnalyzer,
    meta: {
      title: 'Bakta 序列分析'
    }
  },
  {
    path: '/tools/tome',
    name: 'TomeOGT',
    component: TomeOGT,
    meta: {
      title: 'Tome 最适生长温度预测'
    }
  },
  {
    path: '/tools/diamond',
    name: 'DiamondAnalyzer',
    component: DiamondAnalyzer,
    meta: {
      title: 'Diamond 甲烷代谢途径预测'
    }
  },
  {
    path: '/tools/metharct-beta',
    name: 'MethArCTBeta',
    component: MethArCTBeta,
    meta: {
      title: 'MethArCT-Beta 综合分析'
    }
  },
  {
    path: '/analysis/tome-ogt',
    redirect: '/tools/tome'
  },
  {
    path: '/blast',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router